import { IDLE_TIME_DF } from "./env";

let idleTimer: ReturnType<typeof setTimeout> | null = null;
let onIdleCallback: (() => void) | null = null;

const events = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart"
];

let currentIdleTime = IDLE_TIME_DF;

const clearIdleTimer = () => {
  if (idleTimer) {
    clearTimeout(idleTimer);
    idleTimer = null;
  }
};

const startTimer = () => {
  clearIdleTimer();

  idleTimer = setTimeout(() => {
    onIdleCallback?.();
  }, currentIdleTime);
};

const activityHandler = () => {
  startTimer();
};

export const startIdleTracking = (
  idleTime: number,
  onIdle: () => void
) => {
  currentIdleTime = idleTime;
  onIdleCallback = onIdle;

  events.forEach(event =>
    window.addEventListener(event, activityHandler, true)
  );

  startTimer(); // khởi tạo timer ban đầu
};

export const updateIdleTime = (idleTime: number) => {
  currentIdleTime = idleTime;
  startTimer(); // reset timer với thời gian mới
};

export const stopIdleTracking = () => {
  events.forEach(event =>
    window.removeEventListener(event, activityHandler, true)
  );

  clearIdleTimer();
  onIdleCallback = null;
};
